import { GetStaticProps } from 'next';
import AuthorsPage from '@/screens/AuthorsPage/AuthorsPage';
import {
    TAuthorShort,
    TAuthorShortWithImage,
    fetchAuthors,
} from '@/entities/Blogs/service/fetchBlogBySlug';
import { checkImage } from '@/common/app/utils/checkImage';
import { buildRootUrl } from '@/common/app/utils/urlsUtils';

const getLinks = (links?: string): Record<string, string> => {
    try {
        return JSON.parse(links || '{}');
    } catch (error) {
        return {};
    }
};

const normaliseAuthors = async (authors: TAuthorShort[]): Promise<TAuthorShortWithImage[]> => {
    try {
        const images = await Promise.all(
            Object.values(authors).map((i) => {
                return checkImage(`/common/main_${i.slug}/ts`);
            })
        );
        return authors.map((i, idx) => ({ ...i, links: getLinks(i.links), image: images[idx] }));
    } catch (error) {
        return [];
    }
};

export const getStaticProps: GetStaticProps<Record<string, unknown>> = async () => {
    try {
        const pageContent = await fetchAuthors();
        const authors = await normaliseAuthors(pageContent);

        const breadcrumbs = [
            {
                url: `/blog/`,
                title: 'Blogs',
            },
            {
                url: `/blog/authors/`,
                title: 'Authors',
                unlink: true,
            },
        ];

        const meta = {
            title: 'Meet Our TripShock Blog Authors | Travel Experts',
            description: 'Explore our team of expert authors sharing insights on the best things to do. Read articles from our travel editors and stay informed with the latest trends and tips.',
            canonical: buildRootUrl('/blog/authors/'),
        };

        return {
            props: {
                meta,
                authors,
                breadcrumbs,
            },
            revalidate: 3600,
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default AuthorsPage;
